import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from './SEO';
import '../styles/about.css';

export const About: React.FC = () => {
  return (
    <>
      <SEO 
        title="About the Developer"
        description="Meet the developer behind POE2 Skills AI - A passionate ARPG gamer and data analyst creating AI-powered tools for Path of Exile 2 players."
        canonicalUrl="https://www.poe2skills-ai.com/about"
        noindex={true}
      />
      <div className="about-container">
        <h1>About the Developer</h1>
        <div className="about-content">
          <section className="bio">
            <h2>Welcome to My Website!</h2>
            <p>Thank you for giving my site a try—I truly appreciate it.</p>

            <h3>My Gaming Journey</h3>
            <p>My journey with PC RPGs started back in elementary school, around 5th or 6th grade, with Diablo II. I still remember my first experience vividly: a mix of being slightly scared and overwhelmingly curious and excited. That game opened the door to my lifelong love of ARPGs. Over the years, I've enjoyed countless hours exploring the worlds of Fallout, The Elder Scrolls, and Path of Exile—my top three favorites. I've easily spent hundreds of hours immersed in Path of Exile alone.</p>

            <h3>Personal Background</h3>
            <p>A little about me: I'm a senior data analyst in the retail industry, with a wife, a child, and a supportive circle of family and friends. Life has become busier, and while I love gaming, I now have less time to play. With increased responsibilities and stress, I find it harder to fully enjoy the depth of today's RPGs. When I saw the skill tree for Path of Exile II, I felt completely overwhelmed. With over 500 gems to choose from, I just didn't have the time or energy to figure it all out.</p>

            <h3>Why I Created This Site</h3>
            <p>That's when the idea for this website came to life. I wanted to create an AI-powered build advisor to help players, like myself, quickly gain insights and enjoy the game without spending hours researching or trial-and-error.</p>

            <p>I hope this site makes your Path of Exile experience more enjoyable, and I'm committed to continually adding new content to make it even more useful and beginner-friendly.</p>

            <p>Thanks again for visiting, and happy gaming!</p>
          </section>

          <section className="contact">
            <h2>Get in Touch</h2>
            <p>Email: randy.as.a.freelancer@gmail.com</p>
            <div className="social-links">
              <a href="https://github.com/RandyXia123" target="_blank" rel="noopener noreferrer">GitHub</a>
            </div>
          </section>

          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </>
  );
};